import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "@/lib/i18n";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/pages/AuthCallback";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Legal from "@/pages/Legal";
import { CookieBanner } from "@/components/CookieBanner";
import AppLayout from "@/components/layout/AppLayout";
import Overview from "@/pages/app/Overview";
import FloorPlan from "@/pages/app/FloorPlan";
import Orders from "@/pages/app/Orders";
import Kitchen from "@/pages/app/Kitchen";
import Cashier from "@/pages/app/Cashier";
import Reservations from "@/pages/app/Reservations";
import MenuManager from "@/pages/app/MenuManager";
import Staff from "@/pages/app/Staff";
import Subscription from "@/pages/app/Subscription";
import Settings from "@/pages/app/Settings";
import DailyReport from "@/pages/app/DailyReport";
import Invoices from "@/pages/app/Invoices";
import MonthlyReport from "@/pages/app/MonthlyReport";
import Inventory from "@/pages/app/Inventory";
import Support from "@/pages/app/Support";
import PublicBooking from "@/pages/PublicBooking";
import PublicMenu from "@/pages/PublicMenu";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/legal/:doc" element={<Legal />} />
            <Route path="/prenota/:slug" element={<PublicBooking />} />
            <Route path="/menu/:slug" element={<PublicMenu />} />
            <Route path="/ordina/:slug/:tableId" element={<PublicMenu />} />
            <Route path="/app" element={<AppLayout />}>
              <Route index element={<Overview />} />
              <Route path="floor" element={<FloorPlan />} />
              <Route path="orders" element={<Orders />} />
              <Route path="kitchen" element={<Kitchen />} />
              <Route path="cashier" element={<Cashier />} />
              <Route path="reservations" element={<Reservations />} />
              <Route path="menu" element={<MenuManager />} />
              <Route path="staff" element={<Staff />} />
              <Route path="subscription" element={<Subscription />} />
              <Route path="settings" element={<Settings />} />
              <Route path="report" element={<DailyReport />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="monthly" element={<MonthlyReport />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="support" element={<Support />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
  );
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <CookieBanner />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
